import React, { FC, memo } from 'react';
import { classNameMerge } from '../../utils/classNameMerge';
import cls from './IconLabel.module.scss';

type IconLabelProps = {
  name: string;
  /** Empty when the catalogue has no logo for this item: a monogram is drawn instead */
  iconUrl?: string;
  className?: string;
};

const IconLabel: FC<IconLabelProps> = memo(({ name, iconUrl, className }) => {
  return (
    <div className={classNameMerge(cls.Label, className)}>
      {/* the name sits right next to the mark, so the mark itself is decorative */}
      {iconUrl ? (
        <img src={iconUrl} alt="" aria-hidden className={cls.Icon} data-testid="icon-label-image" />
      ) : (
        <span className={cls.Monogram} aria-hidden>
          {name.charAt(0)}
        </span>
      )}
      <span>{name}</span>
    </div>
  );
});

export default IconLabel;
